/**
 * The add-in's own version, stamped onto every telemetry event as
 * `addInVersion` and rendered by AiVA Central's Version posture card.
 *
 * Injected at build time by the release pipeline, which passes the image tag
 * (`1.2.0-dev.10`, `1.2.0`, …) as the `VITE_APP_VERSION` build arg. The tag is
 * a better source than `package.json`: it matches the published container, the
 * installer template pin and the Bitbucket release, so a version seen on the
 * fleet dashboard can be traced to an actual deployment. `package.json` has
 * read `1.0.0` since the repo was created and nothing bumps it.
 *
 * AIVA-6494. This replaces the literal `"0.0.0"` that was hardcoded in
 * `main.tsx` and again as the pre-boot default in `client.ts`. Every add-in in
 * the fleet reported the same string forever, so Version posture could not
 * distinguish one build from another and the "stuck on an old version" rule on
 * the Fleet Dashboard could never fire.
 *
 * Mirrors how `studio-app` resolves its own version in `Sidebar.tsx`.
 *
 * The `-dev` suffix on the fallback is deliberate: a local `npm run dev` build
 * is genuinely not a released version, and saying so is more useful than
 * reporting a plausible-looking number that matches no artefact.
 */
export const ADDIN_VERSION: string = import.meta.env.VITE_APP_VERSION || "0.0.0-dev";
